module.exports = __webpack_public_path__ + "media/images/konintodoke/diagnosis/gouri_shugi_sanbou-5225cf63d4c8405bc13984aeaedbc8db.png";